import { useEffect } from 'react';
import { preloadStudioGenderAssets } from '@/pages/customer/studio/utils/preloadStudioAssets';
import {
	CreateSoftieCardButton,
	CreateSoftieIcon,
	CreateSoftieLabel,
} from './CreateSoftieCard.styles';

const CreateSoftieCard = ({ label, onClick }) => {
	useEffect(() => {
		preloadStudioGenderAssets();
	}, []);

	return (
		<CreateSoftieCardButton
			type="button"
			aria-label={label}
			onClick={onClick}
			onMouseEnter={preloadStudioGenderAssets}
			onFocus={preloadStudioGenderAssets}
		>
			<CreateSoftieIcon aria-hidden="true">
				<svg viewBox="0 0 24 24">
					<path d="M12 5v14M5 12h14" />
				</svg>
			</CreateSoftieIcon>
			<CreateSoftieLabel>{label}</CreateSoftieLabel>
		</CreateSoftieCardButton>
	);
};

export default CreateSoftieCard;
